<template>
	<div class="card">
		<div class="card-header bg-dark">
			<h3 class="mb-0 text-white">ตั้งค่าเกม Betflix</h3>
		</div>
		<el-table row-key="id" header-row-class-name="thead-light" :data="games">
			<el-table-column label="เปิดใช้งาน" min-width="60px">
				<div slot-scope="{ row }" class="text-center">
					<base-checkbox v-model="row.enable" />
				</div>
			</el-table-column>
			<el-table-column label="เกม" min-width="75px">
				<div slot-scope="{ row }">
					[{{ row.type | ucFirst }}] - <b>{{ row.game | upperCase }}</b>
				</div>
			</el-table-column>
			<el-table-column label="ลิมิต" min-width="75px">
				<div slot-scope="{ row }" v-if="row.type === 'casino'">
					<el-select class="select-primary mr-2" v-model="row.limit" required>
						<el-option class="select-primary" label="A" value="A" />
						<el-option class="select-primary" label="B" value="B" />
						<el-option class="select-primary" label="C" value="C" />
						<el-option class="select-primary" label="D" value="D" />
						<el-option class="select-primary" label="E" value="E" />
						<el-option class="select-primary" label="F" value="F" />
					</el-select>
				</div>
			</el-table-column>
			<el-table-column label="คอมมิชชั่น" min-width="75px">
				<div slot-scope="{ row }" v-if="row.type === 'casino'">
					<el-select class="select-primary mr-2" v-model="row.commission" required>
						<el-option class="select-primary" label="0%" :value="0" />
						<el-option class="select-primary" label="0.1%" :value="0.1" />
						<el-option class="select-primary" label="0.2%" :value="0.2" />
						<el-option class="select-primary" label="0.3%" :value="0.3" />
						<el-option class="select-primary" label="0.4%" :value="0.4" />
						<el-option class="select-primary" label="0.5%" :value="0.5" />
						<el-option class="select-primary" label="0.6%" :value="0.6" />
						<el-option class="select-primary" label="0.7%" :value="0.7" />
						<el-option class="select-primary" label="0.8%" :value="0.8" />
						<el-option class="select-primary" label="0.9%" :value="0.9" />
						<el-option class="select-primary" label="1%" :value="1" />
					</el-select>
				</div>
			</el-table-column>
		</el-table>
		<div class="card-footer text-right">
			<button class="btn btn-default" :disabled="loading" @click="saveSetting">
				บันทึกข้อมูล
			</button>
		</div>
	</div>
</template>

<script>
import { Table, TableColumn, Select, Option } from 'element-ui'

import api from '../../services'

export default {
	props: ['betflixGames'],
	components: {
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Select.name]: Select,
		[Option.name]: Option,
	},
	data() {
		return {
			loading: false,
			games: [],
		}
	},
	methods: {
		async saveSetting() {
			this.loading = true

			try {
				const res = await api.post('/setting/website/betflix-games', {
					games: this.games,
				})

				this.$notify({ type: 'success', message: res.message })
			} catch ({ message }) {
				this.$notify({ type: 'danger', message })
			} finally {
				this.loading = false
			}
		},
	},
	mounted() {
		this.games = this.betflixGames
	},
	watch: {
		betflixGames(v) {
			this.games = v
		},
	},
}
</script>
